import { useState } from "react";

export default function EventModal({ date, onClose, onSave }) {
  const [title, setTitle] = useState("");

  const handleSave = () => {
    if (title.trim()) {
      onSave(date, title);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-80">
        <h2 className="text-xl font-bold mb-2">Add Event</h2>
        <p className="text-sm text-gray-500 mb-4">{date}</p>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Event title"
          className="w-full border px-2 py-1 rounded mb-4"
        />
        <div className="flex justify-end gap-2">
          <button
            className="bg-gray-300 text-sm px-4 py-1 rounded"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="bg-blue-500 text-white text-sm px-4 py-1 rounded"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}